/**
 * New Customer Page
 */
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { AppShell } from '../components/layout/AppShell';
import { CustomerForm } from '../components/customers/CustomerForm';
import { useCreateCustomer } from '../hooks/useCustomers';
import { useToastHelpers } from '../components/ui/Toast';

export const Route = createFileRoute('/customers_/new')({
  component: NewCustomerPage,
});

function NewCustomerPage() {
  const navigate = useNavigate();
  const toast = useToastHelpers();
  const createCustomer = useCreateCustomer();

  const handleSubmit = async (data: Parameters<typeof createCustomer.mutate>[0]) => {
    try {
      const customer = await createCustomer.mutateAsync(data);
      toast.success('Kunde erstellt');
      navigate({ to: '/customers/$id', params: { id: customer.id } });
    } catch {
      toast.error('Fehler beim Erstellen');
    }
  };

  return (
    <ProtectedRoute>
      <AppShell>
        {/* Header */}
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-1">
            <Link to="/customers" className="text-white/40 hover:text-white/60">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </Link>
            <span className="text-white/40">Kunden</span>
          </div>
          <h1 className="text-2xl font-semibold text-white">Neuer Kunde</h1>
        </div>

        <CustomerForm
          onSubmit={handleSubmit}
          isLoading={createCustomer.isPending}
          onCancel={() => navigate({ to: '/customers' })}
        />
      </AppShell>
    </ProtectedRoute>
  );
}
